/**
 * Vocabulaire de la gamme produit côté producteur.
 *
 * Aligné sur le domaine backend (`product.ts`) : types de prix fermés pour la
 * V1, catégories d'inscription (pas encore les rayons fins du catalogue client).
 */

export type PriceType = 'kg' | 'piece' | 'litre' | 'botte';

export const PRICE_TYPES: readonly { readonly id: PriceType; readonly label: string }[] = [
  { id: 'kg', label: 'Au kg' },
  { id: 'piece', label: 'À la pièce' },
  { id: 'litre', label: 'Au litre' },
  { id: 'botte', label: 'À la botte' },
];

export const PRICE_TYPE_UNITS: Record<PriceType, string> = {
  kg: 'kg',
  piece: 'pièce',
  litre: 'L',
  botte: 'botte',
};

export type ProductStatus = 'draft' | 'published' | 'archived';

export function priceTypeLabel(type: PriceType): string {
  return PRICE_TYPES.find((entry) => entry.id === type)?.label ?? type;
}

export function unitFor(type: PriceType): string {
  return PRICE_TYPE_UNITS[type];
}

/** Centimes saisis depuis un champ « 4,90 » ou « 4.90 ». */
export function parseEuroToCents(raw: string): number | undefined {
  const normalized = raw.trim().replace(/\s/g, '').replace(',', '.');
  if (normalized.length === 0) {
    return undefined;
  }
  const value = Number(normalized);
  if (!Number.isFinite(value) || value < 0) {
    return undefined;
  }
  return Math.round(value * 100);
}

export function formatCentsAsEuroInput(cents: number): string {
  return (cents / 100).toFixed(2).replace('.', ',');
}

/** « +2,00 €/kg » ou « gratuit ». */
export function formatExtraSurcharge(priceCents: number, unit: string): string {
  if (priceCents === 0) {
    return 'gratuit';
  }
  return `+${formatCentsAsEuroInput(priceCents)} €/${unit}`;
}
